import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button, Form } from "react-bootstrap";
import httpClient from "utility/httpClient.util";
import ListGroup from "react-bootstrap/ListGroup";
const PermissionGroup = (props) => {
  const { show, onHide, savePermission, permissionsDefault } = props;
  const [options, setOptions] = useState([]);
  const [emptyGroup, seEmptyGroup] = useState(true);

  const getGroups = async () => {
    await httpClient.get("/core/kc/groups").then((res) => {
      if (res.status === 200) {
        const Items = res.data.data;
        setOptions(Items.map((item) => ({ ...item, status: false })));
      }
    });
  };

  const handleChange = (item) => {
    seEmptyGroup(false);
    setOptions((prevOptions) =>
      prevOptions.map((opt) =>
        opt.id === item.id ? { ...opt, status: !opt.status } : opt
      )
    );
  };

  const onApply = () => {
    const permission = options.filter((obj) => obj.status === true);
    savePermission(
      permission.map((item) => ({
        id: item.id,
        name: item.name,
        path: item.path,
        subGroups: item.subGroups,
      }))
    );
    resetGroup();
  };

  const resetGroup = () => {
    seEmptyGroup(true);
    const newOptions = options.map((item) => {
      return { ...item, status: false };
    });
    setOptions(newOptions);
  };

  useEffect(() => {
    getGroups();
  }, []);

  useEffect(() => {
    if (permissionsDefault?.length > 0) {
      seEmptyGroup(false);
      setOptions((prevOptions) =>
        prevOptions.map((option) => {
          const isPermissionExist = permissionsDefault.some(
            (permission) => permission.id === option.id
          );
          return isPermissionExist ? { ...option, status: true } : option;
        })
      );
    } else {
      resetGroup();
    }
  }, [permissionsDefault,show]);

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {" "}
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เลือกกลุ่มในกรณีที่ต้องการอนุญาติเฉพาะกลุ่ม
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListGroup as="ol" numbered>
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-center"
            >
              <div className="me-auto">
                <div className="fw-bold">ไม่ระบุกลุ่ม</div>
              </div>
              <div className="form-check">
                <Form>
                  <Form.Check
                    checked={emptyGroup}
                    type="checkbox"
                    onChange={() => resetGroup()}
                  />
                </Form>
              </div>
            </ListGroup.Item>{" "}
            {options.map((item) => {
              return (
                <React.Fragment   key={item?.id}>
                  {" "}
                  <ListGroup.Item 
                
                    as="li"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div className="me-auto">
                      <div className="fw-bold">{item.name}</div>
                    </div>
                    <div className="form-check">
                      <Form>
                        <Form.Check
                          checked={item.status}
                          type="checkbox"
                          onChange={() => handleChange(item)}
                        />
                      </Form>
                    </div>
                  </ListGroup.Item>
                </React.Fragment>
              );
            })}
          </ListGroup>
          <Row className="mt-3">
            <Col md={6}></Col>
            <Col md={6}>
              {" "}
              <Button
                className="w-100"
                onClick={() => onApply()}
                variant="primary"
              >
                {" "}
                Apply{" "}
              </Button>{" "}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default PermissionGroup;
